export const STRIPE_API_KEY = process.env.NEXT_PUBLIC_STRIPE_API_KEY as string;

export const ELEMENTS_APPEARANCE = {};

const getBaseStyles = () => ({
  style: {
    base: {
      fontSize: '16px',
      color: '#161616',
      '::placeholder': {
        color: '#8D8D9C',
      },
    },
    invalid: {
      color: '#FE6170',
    },
  },
});

export const ELEMENT_OPTIONS = {
  ...getBaseStyles(),
};

export const CARD_ELEMENT_OPTIONS = {
  placeholder: 'XXXX XXXX XXXX XXXX',
  ...getBaseStyles(),
};

export const CURRENCY_DOES_NOT_SUPPORT_PAYPAL = [
  'AED',
  'ARS',
  'BGN',
  'CLP',
  'COP',
  'INR',
  'ISK',
  'KRW',
  'PEN',
  'PYG',
  'RSD',
  'RON',
  'SAR',
  'TRY',
  'TWD',
  'UYU',
  'VND',
  'ZAR',
];

export const STRIPE_RETRYABLE_PAYMENT_ERROR_CODES = [
  'authentication_required',
  'authentication_not_handled',
  'approve_with_id',
  'issuer_not_available',
  'processing_error',
  'partner_processing_error',
  'reenter_transaction',
  'try_again_later',
  'mobile_device_authentication_required',
  'expired_payment_information',
  'partner_payment_not_found',
] as const;

export const STRIPE_TRY_ANOTHER_CARD_PAYMENT_ERROR_CODES = [
  'call_issuer',
  'card_not_supported',
  'card_velocity_exceeded',
  'currency_not_supported',
  'partner_invalid_currency',
  'do_not_try_again',
  'expired_card',
  'partner_expired_card',
  'fraudulent',
  'lost_card',
  'stolen_card',
  'merchant_blacklist',
  'invalid_account',
  'new_account_information_available',
  'not_permitted',
  'transaction_not_allowed',
  'offline_pin_required',
  'online_or_offline_pin_required',
  'pickup_card',
  'pin_try_exceeded',
  'restricted_card',
  'invalid_billing_agreement',
  'invalid_authorization',
  'invalid_payment_information',
  'recurring_not_supported_by_bank',
  'invalid_customer_account',
  'partner_high_risk_customer',
  'compliance_violation',
  'partner_generic_decline',
] as const;

export const STRIPE_PAYMENT_DECLINED_MODAL_ERROR_CODES = [
  'do_not_honor',
  'generic_decline',
  'no_action_taken',
  'security_violation',
  'service_not_allowed',
  'stop_payment_order',
  'revocation_of_all_authorizations',
  'revocation_of_authorization',
  'insufficient_funds',
  'partner_insufficient_funds',
  'withdrawal_count_limit_exceeded',
  'payment_limit_exceeded',
] as const;

export const STRIPE_PAYMENT_DECLINED_DISMISS_TRY_ANOTHER_CARD_ERROR_CODES = [
  'do_not_honor',
  'generic_decline',
  'no_action_taken',
  'security_violation',
  'service_not_allowed',
  'stop_payment_order',
  'revocation_of_all_authorizations',
  'revocation_of_authorization',
] as const;
